import * as R from 'ramda'
import ActionType from './action-types'
import { Api } from '../lib'

const node_api = new Api({ node_api: true })

const create = body => (dispatch, getState) =>
  node_api
    .post('subscription', {
      body: {
        billing_interval: body.billing_interval,
        billing_period: body.billing_period,
        shipping: R.pick([
          'address_1',
          'address_2',
          'city',
          'state',
          'postcode',
        ])(body.shipping),
        products: R.map(item => ({
          product_id: item.id,
          variation_id: item.variation.variation_id,
          quantity: item.quantity,
        }))(getState().cart.cart_content),
      },
    })

    .then(result =>
      dispatch({ type: ActionType.CREATED_SUBSCRIPTION, payload: result.data })
    )

const remove = id => dispatch =>
  node_api
    .delete('subscription_by_id', { keys: { id } })

    .then(() =>
      dispatch({ type: ActionType.DELETED_SUBSCRIPTION, payload: id })
    )

export default {
  create,
  remove,
}
